import { inject, Injectable } from '@angular/core';

import { Capacitor } from '@capacitor/core';
import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { Store } from '@ngrx/store';

import * as fromPushNotificationsActions from '../../store/actions/push-notifications.actions';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationsService {
  private store = inject(Store);

  async init() {
    if (Capacitor.isNativePlatform()) {
      const { receive } = await PushNotifications.checkPermissions();
      if (['prompt', 'prompt-with-rationale'].includes(receive)) {
        const { receive } = await PushNotifications.requestPermissions();
        if (['granted'].includes(receive)) {
          await this.register();
        }
      } else if (['granted'].includes(receive)) {
        await this.register();
      }
    }
  }

  async register() {
    await PushNotifications.addListener('registration', (payload: Token) => {
      this.store.dispatch(fromPushNotificationsActions.registrationSuccess({ payload }));
    });

    await PushNotifications.addListener('registrationError', (error) => {
      this.store.dispatch(
        fromPushNotificationsActions.registrationFailure({ payload: { error: new Error(error.error) } })
      );
    });

    await PushNotifications.addListener('pushNotificationReceived', (payload: PushNotificationSchema) => {
      this.store.dispatch(fromPushNotificationsActions.notificationReceived({ payload }));
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', (payload: ActionPerformed) => {
      this.store.dispatch(fromPushNotificationsActions.notificationActionPerformed({ payload }));
    });

    this.store.dispatch(fromPushNotificationsActions.registration());

    await PushNotifications.register();
  }
}
